/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".carousel-title[_ngcontent-%COMP%]{font-family:SEGOEUIL,\"Helvetica Neue\",sans-serif;font-size:22px;font-weight:400;margin-top:40px;margin-bottom:2px;line-height:48px}.catories-children-all[_ngcontent-%COMP%]{margin-left:auto;width:auto;color:#26809d}.category-slider-row[_ngcontent-%COMP%]{margin-top:1em}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/home-page/category/category.component.scss.shim.ngstyle.js.pre-build-optimizer.js